module.exports = __webpack_public_path__ + "static/media/sura-no-option-selected.5a10daef.svg";